<template>
  <!-- drawer realistic record add -->
  <el-drawer
    :title="editorText + '等级赋分得分规则'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="rules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="得分描述" prop="level">
            <div v-for="(level, index) in form.level" :key="level.value" style="margin-left: 15px;">
              <span
                class="level"
                :style="{background: _.filter(levels, {value: level.level})[0].color}"
              >{{ _.filter(levels, {value: level.level})[0].name }}</span>
              <span style="font-size: 14px; color: #757575;">得分比例</span>
              <el-input-number
                :min="0"
                :max="100"
                v-model.trim="level.score"
                :controls="false"
                :disabled="index === 0"
              ></el-input-number>
              <span>%</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :disabled="submitting" @click="submitForm('form')">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import _ from 'lodash'
import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    var validateLevel = (rule, value, callback) => {
      if (value) {
        let scoreArr = _.map(value, 'score')
        scoreArr.indexOf(undefined)
        if (scoreArr.indexOf(undefined) !== -1 || scoreArr.indexOf(null) !== -1) {
          this.submitting = false
          callback(new Error('得分比例不得为空'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      rules: {
        level: [
          { required: true, message: '得分描述不得为空', trigger: 'blur' },
          { validator: validateLevel, trigger: 'blur' }
        ]
      },
      submitting: false,
      form: { id: null, level: [] },
      levels: [
        {
          name: 'A',
          color: '#2DC16E',
          value: 1
        },
        {
          name: 'B',
          color: '#649CEE',
          value: 2
        },
        {
          name: 'C',
          color: '#EEBD64',
          value: 3
        },
        {
          name: 'D',
          color: '#FF6C6B',
          value: 4
        }
      ],
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' },
    _ () {
      return _
    }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.$refs.form && this.$refs.form.resetFields()
      this.submitting = false
      let arr = []
      arr[0] = 100
      this.form.level = this.identify.scoreArr || arr
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    xhrUpdate () {
      let scoreArr = []
      for (let index = 0; index < this.form.level.length; index++) {
        let element = this.form.level[index]
        let temp = {
          level: index + 1,
          score: element.score
        }
        scoreArr.push(temp)
      }
      let realFormData = {
        content: scoreArr,
        ruleConfigId: this.identify.ruleConfigId,
        ruleId: this.identify.ruleInfo.id,
        ruleType: this.identify.ruleInfo.type
      }
      if (_.uniq(this.form.level).includes(undefined)) {
        this.$message.error('得分比例不得为空')
        this.submitting = false
        return false
      }
      if (__.isObjectPropertiesAllNull(realFormData)) {
        this.submitting = false
        this.$message.error('请修改信息后提交')
        return
      }
      this.$xhrPut(`/eval/indicators/scoring-rule-config`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    xhrAdd () {
      if (_.uniq(this.form.level).includes(undefined)) {
        this.$message.error('得分比例不得为空')
        this.submitting = false
        return false
      }
      let scoreArr = []
      for (let index = 0; index < this.form.level.length; index++) {
        let element = this.form.level[index]
        let temp = {
          level: index + 1,
          score: element.score
        }
        scoreArr.push(temp)
      }
      let realFormData = {
        content: scoreArr,
        ruleConfigId: this.identify.ruleConfigId,
        ruleId: this.identify.ruleInfo.id,
        ruleType: this.identify.ruleInfo.type
      }
      this.$xhrPost(`/eval/indicators/scoring-rule-config`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.$message.error('请检查输入')
          this.submitting = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input-number {
  width: 80px;
}
/deep/ .el-input {
  width: 100%;
}
.level {
  display: inline-block;
  margin-right: 75px;
  height: 24px;
  width: 24px;
  border-radius: 2px;
  text-align: center;
  line-height: 24px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddLevelScore.vue